import { Outlet } from "react-router-dom";
import { Topbar } from "./components/Topbar";

export function App() {
  return (
    <div className="flex min-h-full flex-col">
      <Topbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-border py-6 text-center text-xs text-muted-foreground">
        Atelier — open source · runs on your own chain, wallet, and IPFS pin.
      </footer>
    </div>
  );
}
